<template>
  <div class="grid-y items-center justify-center flex-grow py-12">
    <img class="mb-10" src="@/assets/images/iwaly.svg" alt="iwaly">
    <b>Вход в аккаунт администратора</b>
    <span>Введите логин и пароль</span>
    <div class="input-container flex flex-col">
      <Input
        placeholder="Ваш логин"
        :invalid="$v.login.$error"
        v-model="login"
        @keyup.enter.native="send()"/>
      <Input
        placeholder="Введите пароль"
        type="password"
        :invalid="$v.password.$error"
        v-model="password"
        @keyup.enter.native="send()"/>
      <!--
      OTP temporarily disabled. Keep this block for a possible future return of 2FA.
      <Input
        placeholder="Код подтверждения"
        :invalid="$v.code.$error"
        :inputmask="{
          mask: '999 999',
          placeholder: '',
          showMaskOnHover: false,
          showMaskOnFocus: false,
        }"
        v-model="code"
        @keyup.enter.native="send()"/>
      -->
      <button class="btn btn-primary font-rubik" @click="send()">Войти</button>
      <div
        class="validation-container"
        v-if="$v.$dirty && $v.$error">
        <small class="text-danger">Заполните все необходимые поля</small>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import Input from '@/components/Input.vue';

export default {
  components: {
    Input,
  },
  data() {
    return {
      login: '',
      password: '',
      // OTP temporarily disabled. Keep for a possible future return of 2FA.
      // code: '',
    };
  },
  validations: {
    login: {
      required,
    },
    password: {
      required,
    },
    // OTP temporarily disabled. Keep for a possible future return of 2FA.
    // code: {
    //   required,
    // },
  },
  methods: {
    ...mapActions({
      authenticate: 'auth/ACT_AUTHENTICATE',
    }),
    send() {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.$wait.is('authenticate')) {
        this.authenticate({
          login: this.login,
          password: this.password,
          // OTP temporarily disabled. Keep for a possible future return of 2FA.
          // otp: parseInt(this.code.replace(/\s/g, ''), 10),
        });
      }
    },
  },
};
</script>
